import React, { useEffect, useState } from "react";
import "./Diaper_changing.css";
import Accordion from "react-bootstrap/Accordion";
import { diaper_img, formula_accordian_img, Solid, wet } from "assets/icons";
import useFullPageLoader from "common/UseFullPageLoader";
import { diaperListApi } from "services/diaper";
import moment from "moment";
import { firstWordCapital } from "utils/common";
import { dateFormatWithTime } from "utils/dateFormat";

const Diaper_changing = ({ _child }) => {
  const [loader, onShow, onHide] = useFullPageLoader();
  const [feedingList, setFeedingList] = useState([]);
  const [meta, setMeta] = useState({});
  const [selected, setSelected] = useState({});


  const fetchData = async () => {
    try {
      onShow();
      const { data, status } = await diaperListApi({ childId: _child, limit: 5000 });
      if (status === 200) {
        setFeedingList(data?.data);
        setMeta(data?.meta);
      }
    } catch (e) {
      console.log(e);
    } finally {
      onHide();
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <>
      <div className="diaper_changing_parent">
        <div className="diaper_changing_wraper">
          <div className="row">
            <div className="col-lg-6 col-md-6 col-sm-12">
              <div className="formula_lft_side">
                <div className="formula_accordian">
                  <Accordion className="w-75">
                    <p className="formula_logo">Diaper Logs</p>
                    {
                      feedingList?.map((feeding, i) => {
                        return <Accordion.Item eventKey={i} key={i}>
                          <Accordion.Header>
                            <div className="formula_header">
                              <h6>{moment(feeding._id, "YYYY-MM-DD").format("LL")}</h6>
                            </div>
                          </Accordion.Header>

                          {
                            feeding?.documents?.map((ele, j) => {
                              return <Accordion.Body key={j} onClick={() => setSelected(ele)}>
                                <div className="formula_timimg_inside">
                                  <div className="formula_timing_wraper">
                                    {/* <div className="formula_lft_img">
                                      <img src={wet} />
                                    </div> */}
                                    <div className="img_rgt_wraper">
                                      <div className="first_img">
                                        <img src={diaper_img} alt="" />
                                      </div>
                                    </div>

                                    <div className="formula_rgt_content">
                                      <div className="formula_rgt_top">
                                        <div className="formula_timimg">
                                          <span>{firstWordCapital(ele.size?.toLowerCase())}</span> <span>{dateFormatWithTime(ele?.dateTime)}</span>
                                          <div className="formula_liter">
                                            <b>{firstWordCapital(ele?.diaper?.toLowerCase())}</b>
                                          </div>
                                        </div>
                                      </div>
                                    </div>

                                    {/* <div className="img_rgt_wraper">
                                      <div className="first_img">
                                        <img src={diaper_img} alt="" />
                                      </div>

                                      <div className="second_img">
                                        <img src={diaper_img} alt="" />
                                      </div>
                                    </div> */}
                                  </div>
                                </div>
                              </Accordion.Body>
                            })
                          }
                        </Accordion.Item>
                      })
                    }
                  </Accordion>
                </div>
              </div>
            </div>

            {
              selected?._id
                ?
                <div className="col-lg-6 col-md-6 col-sm-12">
                  <div className="formula_right_side ">
                    <div className="doctor_visit_rgt">
                      <div className="doctor_visit_card">
                        <b>Diaper</b>
                        <div className="date-time">{firstWordCapital(selected?.diaper?.toLowerCase())}</div>

                        <b>Date & Time</b>
                        <div className="date-time">
                          {dateFormatWithTime(selected?.dateTime)}
                          <br />
                        </div>

                        <b> Size</b>
                        <div className="date-time">{firstWordCapital(selected?.size?.toLowerCase())}</div>

                        {/* <b> Colour</b>
                        <div className="date-time">Dark Green</div> */}

                        <b>Type</b>
                        <div className="date-time">{firstWordCapital(selected?.type?.toLowerCase())}</div>

                        <b>Note</b>
                        <div className="motorskilltracking-note feeding_note">
                          <p>
                            {selected?.note}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>

                  
                </div>
                :
                null
            }

          </div>
        </div>
      </div>
    </>
  );
};

export default Diaper_changing;
